module.exports = __webpack_public_path__ + "img/capital-xtra.911a781c.png";